/** Loading and empty states, said plainly. BRAND.md §7: no exclamation, no hedging. */

export function LoadingState({ what }: { what: string }) {
  return <p className="py-12 text-[12.5px] text-eq-helper">Loading {what}…</p>
}

export function EmptyState({ children }: { children: React.ReactNode }) {
  return <p className="py-12 text-[14px] text-eq-neutral">{children}</p>
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="rounded-eq-md border border-eq-danger bg-eq-danger-bg px-4 py-3 text-[14px] text-eq-danger">
      {message}
    </div>
  )
}
